import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortNumber',
})
export class ShortNumberPipe implements PipeTransform {
  transform(number: number, args?: any): any {
    if (Number.isNaN(number)) return null;
    if (number === null) return null;
    if (number < 10000) return number;
    let abs = Math.abs(number);
    const rounder = 10 ** 1;
    const isNegative = number < 0;
    let key = '';

    const powers = [
      { key: 'Q', value: 10 ** 15 },
      { key: 'T', value: 10 ** 12 },
      { key: 'B', value: 10 ** 9 },
      { key: 'M', value: 10 ** 6 },
      { key: 'K', value: 1000 },
    ];

    for (let i = 0; i < powers.length; i += 1) {
      let reduced = abs / powers[i].value;
      reduced = Math.round(reduced * rounder) / rounder;
      if (reduced >= 1) {
        abs = reduced >= 100 ? Math.round(reduced) : reduced;
        key = powers[i].key;
        break;
      }
    }
    return (isNegative ? '-' : '') + abs + key;
  }
}
